import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RemoveInternalTaskFileService } from './remove-internal-task-file.service';

@NgModule({
  imports: [CommonModule],
  providers: [RemoveInternalTaskFileService],
})
export class TasksInternalFileModule {}
